export { default } from './Popover';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Popover/index.js
// module id = 139
// module chunks = 0